'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'

type ScrollToTopOnInvestorsProps = {
  children: ReactNode
  locale: string
  className?: string
}

export default function ScrollToTopOnInvestors({ children, locale, className }: ScrollToTopOnInvestorsProps) {
  const pathname = usePathname()
  const isInvestorsPage = pathname?.includes('/investors')

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isInvestorsPage) {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    // If not on investors page, let the Link handle navigation normally
  }

  return (
    <Link href={`/${locale}/investors`} className={className} onClick={handleClick}>
      {children}
    </Link>
  )
}
